<template>
  <div class="page">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="资讯" name="资讯">
        <ul>
          <li
            class="list_item"
            v-for="item in list"
            :key="item.id"
            @click="handleShowDetail(item.contentId)"
          >
            <div class="desc">
              {{ item.articleDto && item.articleDto.title }}
            </div>
            <div class="info">
              <div class="left">
                <div>{{ item.articleDto && item.articleDto.typeName }}</div>
                <span>{{ item.articleDto && item.articleDto.keywords }}</span>
                <!-- <span>#实验室</span> -->
              </div>
              <div class="right">
                <div>来源：{{ item.articleDto && item.articleDto.link }}</div>
                <div class="xian"></div>
                <div class="create_time">
                  发布时间：{{ item.articleDto && item.articleDto.sourceDate }}
                </div>
              </div>
            </div>
            <el-divider></el-divider>
          </li>
        </ul>
        <div ref="page">
          <pagination
            v-show="total > 0"
            :total="total"
            :page.sync="queryParams.pageNo"
            :limit.sync="queryParams.pageSize"
            @pagination="getList"
          />
        </div>
      </el-tab-pane>
      <el-tab-pane label="文献" name="文献">
        <el-button
          plain
          size="mini"
          @click="thesis"
          :class="queryParams.typeName == '论文' ? 'active' : ''"
          >论文</el-button
        >
        <el-button
          plain
          size="mini"
          @click="periodical"
          :class="queryParams.typeName == '期刊' ? 'active' : ''"
          >期刊</el-button
        >
        <div v-if="queryParams.typeName == '论文'">
          <ul style="max-height: 540px; margin-top: 10px">
            <li
              class="list_item"
              v-for="item in list"
              :key="item.id"
              @click="handleShowDetail(item.contentId)"
            >
              <div class="desc">{{ item.articleDto.title }}</div>
              <div class="info">
                <div class="left">
                  <div>{{ item.articleDto.typeName }}</div>
                  <span>{{ item.articleDto.keywords }}</span>
                  <!-- <span>#实验室</span> -->
                </div>
                <div class="right">
                  <div>来源：{{ item.articleDto.link }}</div>
                  <div class="xian"></div>
                  <div class="create_time">
                    发布时间：{{ item.articleDto.sourceDate }}
                  </div>
                </div>
              </div>
              <el-divider></el-divider>
            </li>
          </ul>
          <div ref="page">
            <pagination
              v-show="total > 0"
              :total="total"
              :page.sync="queryParams.pageNo"
              :limit.sync="queryParams.pageSize"
              @pagination="getList"
            />
          </div>
        </div>
        <div v-if="queryParams.typeName == '期刊'">
          <div class="grid-container">
            <div class="grid-item" v-for="item in list" :key="item.id">
              <el-image
                :src="
                  require('@/assets/coverBucket/' +
                    item.journalDto.periodicalSrc +
                    '.png')
                "
                alt=""
                lazy
              />
              <span>{{ item.journalDto.periodicalName }}</span>
            </div>
          </div>
          <div ref="page">
            <pagination
              v-show="total > 0"
              :total="total"
              :page.sync="queryParams.pageNo"
              :limit.sync="queryParams.pageSize"
              @pagination="getList"
            />
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
    <!-- <el-empty description="描述文字" v-if="list.length==0"></el-empty> -->
  </div>
</template>

<script>
import { getCollectionPage } from "@/api/api.js";
export default {
  data() {
    return {
      activeName: "资讯",
      list: [],
      total: 0,
      queryParams: {
        pageNo: 1,
        pageSize: 10,
        typeName: "资讯",
      },
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      getCollectionPage(this.queryParams).then((res) => {
        console.log(res.data.data);
        this.list = res.data.data.rows;
        console.log(this.list);
        this.total = res.data.data.totalRows;
      });
    },
    handleClick(e) {
      if (e.label == "文献") this.queryParams.typeName = "论文";
      else this.queryParams.typeName = e.label;
      this.reset();
    },
    reset() {
      this.queryParams.pageNo = 1;
      this.list = [];
      this.getList();
    },
    // 论文
    thesis() {
      this.queryParams.typeName = "论文";
      this.reset();
    },
    // 期刊
    periodical() {
      this.queryParams.typeName = "期刊";
      this.reset();
    },
    handleShowDetail(id) {
      let routerUrl = this.$router.resolve({
        path: "/articleDetails",
        query: { id },
      });
      window.open(routerUrl.href);
    },
  },
};
</script>

<style scoped lang="scss">
.page {
  position: relative;
  height: 100%;
}
::v-deep .pagination-container .el-pagination {
  right: 0;
  position: absolute;
  bottom: 0;
}
ul {
  max-height: 580px;
  overflow: auto;
  padding-right: 7px;
}
.list_item {
  cursor: pointer;
  .desc {
    margin-bottom: 15px;
    color: #000;
    font-weight: 600;
  }
  .info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .left > * {
      display: inline-block;
    }
    .right > * {
      display: inline-block;
    }
    .left {
      span {
        color: #0d6ec4;
        margin-left: 10px;
      }
      div {
        background: #f5f5f5;
        padding: 3px 7px;
        color: #aeabae;
      }
    }

    .right {
      .xian {
        width: 1px;
        height: 15px;
        background: #979497;
        position: relative;
        top: 2px;
        margin: 0 15px;
      }
      div {
        color: #979497;
      }
    }
  }
}
.el-divider--horizontal {
  margin: 15px 0;
}
::v-deep .el-tabs__nav-wrap::after {
  background: #fff;
}
::v-deep .el-tabs {
  height: 100%;
  .el-tabs__content {
    height: calc(100% - 55px);
  }
}
.active {
  color: #3a8ee6;
  border-color: #3a8ee6;
}
.grid-container {
  max-height: 540px;
  margin-top: 10px;
  overflow: auto;
  display: grid;
  grid-template-columns: auto auto auto auto auto;
  .grid-item {
    width: 100px;
    min-height: 200px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .el-image {
      width: 100px;
      height: 150px;
    }
    span {
      text-align: center;
    }
  }
}
</style>
